import WidgetContactUsContainer from 'components/WidgetContactUs/WidgetContactUsContainer'
import WidgetContactUsPresentation from 'components/WidgetContactUs/WidgetContactUsPresentation'
import WidgetContactUsData from 'components/WidgetContactUs/WidgetContactUsData'

export default {
  Container: WidgetContactUsContainer,
  Presentation: WidgetContactUsPresentation,
  Data: WidgetContactUsData,
}
